module.exports = __webpack_public_path__ + "media/images/newsletter-default-15205e959c836cceb3a4c226f8667967.jpg";